import React, { useState } from 'react';
import styled from '@emotion/styled';
import { TabContainer } from 'assets/containers/AssetDetailView/styles';
import useMixpanel from 'utils/hooks/Mixpanel';

const AssetDrawerTabs = styled(({ className, assetTabs, isEkg }) => {
  const mixpanelTrack = useMixpanel();
  const [activeTab, setActiveTab] = useState();

  const onTabChange = key => {
    const tab = assetTabs.find(tab => tab.tabKey === key);
    if (tab) {
      setActiveTab(tab.tabKey);
      mixpanelTrack(`Discover - ${isEkg ? 'Discovered' : ''} Facility Drawer - ${tab?.tabName || ''} Tab - Click`);
    }
  };

  const items = assetTabs.map(tab => ({
    key: tab.tabKey,
    label: tab.title,
    children: tab.content,
  }));

  return <TabContainer items={items} className={className} onChange={onTabChange} activeKey={activeTab} />;
})`
  background-color: #212121;
  bottom: 0;
  padding: 10px;

  .ant-tabs-content-holder {
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0.6em;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ffffff;
      border-radius: 30px;
      border: 1px solid black;
    }
  }
`;

export default AssetDrawerTabs;
